import React from "react";
import PageHeading from "../../components/PageHeading";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import * as Yup from "yup";
import customPriceServices from "../../services/customPrice";
import CustomPriceForm from "../../components/Forms/CustomPriceForm";

const initialValues = {
  custom_price: "",
  user_id: "",
  subitem_id: "",
};
const validationSchema = Yup.object().shape({
  custom_price: Yup.number()
    .typeError("يجب ان يكون رقم")
    .required("هذا الحقل مطلوب"),
  user_id: Yup.number()
    .typeError("يجب ان يكون رقم")
    .required("هذا الحقل مطلوب"),
});

const AddCustomPrice = ({ title }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const onSubmit = (values, { setSubmitting }) => {
    customPriceServices
      .addCustomPrice(values)
      .then(() => {
        toast.success("تمت الإضافة بنجاح");
        setTimeout(() => {
          setSubmitting(false);
        }, 1500);
        navigate(`/subitems/${id}/custom-prices`);
      })
      .catch((err) => {
        if (err && err.response.status === 422) {
          toast.error("سجل غير موجود");
        } else {
          toast.error("حصل خطأ");
        }
      });
    setTimeout(() => {
      setSubmitting(false);
    }, 1500);
  };

  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <CustomPriceForm
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        subitemId={id}
        isUpdate={false}
        initialValues={{
          ...initialValues,
          subitem_id: id,
        }}
        btnText="إرسال"
      />
    </div>
  );
};

export default AddCustomPrice;
